export enum BrandsMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_BRANDS = 'SET_BRANDS',
  SET_SELECTED_BRANDS = 'SET_SELECTED_BRANDS',
  SET_SEARCH = 'SET_SEARCH',
}
